/**
 * node-crc32-stream
 *
 * Copyright (c) 2014 Chris Talkington, contributors.
 * Licensed under the MIT license.
 * https://github.com/archiverjs/node-crc32-stream/blob/master/LICENSE-MIT
 */

'use strict';

module.exports = {
  CRC32Stream: require('./crc32-stream'),
  DeflateCRC32Stream: require('./deflate-crc32-stream')
}
